import * as components from './components'

export default [
  {
    path: '/channel/list',
    component: components.ListChannels,
    name: 'listChannels',
    props: true
  },
  {
    path: '/channel/create',
    component: components.CreateChannel,
    name: 'createChannel',
    props: true
  },
  {
    path: '/channel/:uuid/detail',
    component: components.ChannelDetail,
    name: 'channelDetail',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/channel/routes.js